import React, { Fragment } from 'react'

import { useMediaQueries } from 'hooks'

import { primitivePropsAreEqual } from 'helpers/react'

import Width from 'components/_old/Width/Width'

import { Paper } from 'components/atoms/Paper'

import ColumnarLayout from 'components/molecules/ColumnarLayout/ColumnarLayout.jsx'

import { PastPerformanceCard, PastPerformanceTable, PastPerformanceDisclaimer } from './components'
import { findYearByValue } from './model'

type PastPerformanceProps = Partial<{
  yearly: Record<string, string>
  best_year: string
  worst_year: string
  average_annual_return: string
  worst_12m_period: string
}>

const PastPerformance = React.memo<PastPerformanceProps>(
  ({
    yearly,
    /* eslint-disable @typescript-eslint/naming-convention */
    best_year,
    worst_year,
    worst_12m_period,
    average_annual_return,
    /* eslint-enable */
  }: PastPerformanceProps): React.ReactElement => {
    const { desktop } = useMediaQueries()
    const bestYear = findYearByValue(yearly, best_year)
    const worstYear = findYearByValue(yearly, worst_year)

    return (
      <Fragment>
        <ColumnarLayout mods={{ padding: 'no' }}>
          <Paper right={4}>
            <PastPerformanceCard title="Avg. annual return" value={average_annual_return} />
          </Paper>
          <Paper left={4}>
            <PastPerformanceCard title={`Best year ${bestYear ? ', ' + bestYear : ''}`.trim()} value={best_year} />
          </Paper>
        </ColumnarLayout>
        <Paper top={8}>
          <ColumnarLayout mods={{ padding: 'no' }}>
            <Paper right={4}>
              <PastPerformanceCard
                title={`Worst year ${worstYear ? ', ' + worstYear : ''}`.trim()}
                value={worst_year}
              />
            </Paper>
            <Paper left={4}>
              <PastPerformanceCard title="Worst 12 mo. period" value={worst_12m_period} />
            </Paper>
          </ColumnarLayout>
        </Paper>
        <Paper top={24}>
          <Width size={desktop ? 19 : null} center>
            <PastPerformanceTable yearly={yearly} />
          </Width>
        </Paper>
        <Paper top={24}>
          <PastPerformanceDisclaimer />
        </Paper>
      </Fragment>
    )
  },
  primitivePropsAreEqual,
)

PastPerformance.displayName = 'PastPerformance'

export { type PastPerformanceProps, PastPerformance }
